// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphHeroImage.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphHeroImage.tsx");
  import.meta.hot.lastModified = "1740183864616.2307";
}
// REMIX HMR END

import clsx from "clsx";
import { Image } from "@unpic/react";
import Button from "~/components/Button";
import htmlParser from "../helpers/htmlParser";
import Heading from "../Heading";
const aligmentVariants = {
  left: {
    image: "md:col-start-1",
    text: "md:col-start-12"
  },
  right: {
    image: "md:col-start-12",
    text: "md:col-start-1"
  }
};
export default function HeroImage({
  alignment,
  title,
  subtitle,
  text,
  image: {
    mediaImage
  },
  cta,
  variant
}) {
  const {
    image,
    text: textAlignment
  } = aligmentVariants[alignment];
  const components = htmlParser({
    html: text.processed || ""
  });
  if (variant === "secondary") {
    return <div className="z-10 flex md:pt-14 flex-col md:grid md:grid-cols-20 pt-3">
        <section className={clsx("flex flex-col items-start justify-center gap-4 py-8", "col-start-1 col-span-full", "md:justify-start md:pt-4 md:col-span-10 md:pr-[10%] md:pb-0", textAlignment)}>
          <Heading tag="h1" className="!text-neutral-100">
            {title}
          </Heading>
          <div dangerouslySetInnerHTML={{
          __html: text?.processed
        }} className="text-neutral-100 text-lg" />
          {cta?.map(cta => <Button to={cta.url ? cta.url : "/"} variant="tertiary" size="xl" key={cta.title}>
              {cta.title}
            </Button>)}
        </section>
        <Image layout="constrained" className={clsx("mb-4 md:mb-0 self-center object-scale-down md:col-span-9 md:row-start-1", image)} src={mediaImage.url} alt={mediaImage.alt} width={mediaImage.width} height={mediaImage.height} />
      </div>;
  }
  return <section className={clsx("flex flex-col items-center", "md:grid md:grid-cols-20 md:text-left md:items-stretch")}>
      <Image layout="constrained" className={clsx("mb-4 md:mb-0 self-center object-scale-down md:col-span-9 md:row-start-1", image, "hidden md:block")} src={mediaImage.url} alt={mediaImage.alt} width={mediaImage.width} height={mediaImage.height} />
      <hgroup className={clsx("md:col-span-9 md:row-start-1", textAlignment)}>
        <Heading tag="h2">
          {title}
        </Heading>
        <Image layout="constrained" className={clsx("mb-4 md:mb-0 self-center object-scale-down md:col-span-9 md:row-start-1", image, "md:hidden")} src={mediaImage.url} alt={mediaImage.alt} width={mediaImage.width} height={mediaImage.height} />
        {subtitle && <p className="text-xl text-primary-700 font-semibold mb-4 md:mb-8">
            {subtitle}
          </p>}
        <div className="wysiwyg mb-4 wysiwyg-p:mb-4">
          <div>{components}</div>
        </div>
        {cta && cta.length > 0 && <div className="flex flex-wrap">
            {cta.map(({
          title,
          url
        }) => <Button variant="secondary" to={url} key={title}>
                {title}
              </Button>)}
          </div>}
      </hgroup>
    </section>;
}
_c = HeroImage;
var _c;
$RefreshReg$(_c, "HeroImage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;